export default {
  'center.type.1': 'Buddhistisches Zentrum',
  'center.type.2': 'Buddhistische Gruppe',
  'center.type.16': 'Buddhistische Gruppe',
  'center.type.3': 'Buddhistisches Retreatzentrum',
  'center.type.6': 'Buddhistisches Retreatzentrum',
  'center.type.7': 'Buddhistisches Zentrum',
  'center.type.4': 'Buddhistischer Kontakt',
  'center.contact.private':
    'Bitte direkt mit dem Zentrum kontakt aufnehmen, um die Adresse zu erfragen.',
  'phone.short.mobile': 'Tel.',
  'phone.short.mobile2': 'Tel.',
  'phone.short.fax': 'Fax',
  'phone.short.home': 'Tel.',
  'phone.short.other': 'Tel.',
  'phone.short.private': 'Tel.',
  'global.more': 'mehr',
  'global.less': 'weniger',
  'country.long.AF': 'Afghanistan',
  'country.long.EG': 'Ägypten',
  'country.long.AX': 'Aland Islands',
  'country.long.AL': 'Albanien',
  'country.long.DZ': 'Algerien',
  'country.long.AS': 'Amerikanisch-Samoa',
  'country.long.AD': 'Andorra',
  'country.long.AO': 'Angola',
  'country.long.AI': 'Anguilla',
  'country.long.AQ': 'Antarktis',
  'country.long.AG': 'Antigua und Barbuda',
  'country.long.GQ': 'Äquatorialguinea',
  'country.long.AR': 'Argentinien',
  'country.long.AM': 'Armenien',
  'country.long.AW': 'Aruba',
  'country.long.AZ': 'Aserbaidschan',
  'country.long.ET': 'Äthiopien',
  'country.long.AU': 'Australien',
  'country.long.BS': 'Bahamas',
  'country.long.BH': 'Bahrain',
  'country.long.BD': 'Bangladesch',
  'country.long.BB': 'Barbados',
  'country.long.BE': 'Belgien',
  'country.long.BZ': 'Belize',
  'country.long.BJ': 'Benin',
  'country.long.BM': 'Bermuda',
  'country.long.BT': 'Bhutan',
  'country.long.BO': 'Bolivien',
  'country.long.BA': 'Bosnien und Herzegowina',
  'country.long.BW': 'Botswana',
  'country.long.BV': 'Bouvetinsel',
  'country.long.BR': 'Brasilien',
  'country.long.VG': 'Britische Jungferninseln',
  'country.long.IO': 'Britisches Territorium im Indischen Ozean',
  'country.long.BN': 'Brunei Darussalam',
  'country.long.BG': 'Bulgarien',
  'country.long.BF': 'Burkina Faso',
  'country.long.BI': 'Burundi',
  'country.long.CL': 'Chile',
  'country.long.CN': 'China',
  'country.long.CC': 'Cocos (Keeling) Islands',
  'country.long.CD': 'Congo',
  'country.long.CG': 'Congo (Brazzaville)',
  'country.long.CK': 'Cookinseln',
  'country.long.CR': 'Costa Rica',
  'country.long.CI': 'Elfenbeinküste',
  'country.long.DK': 'Dänemark',
  'country.long.DE': 'Deutschland',
  'country.long.DM': 'Dominica',
  'country.long.DO': 'Dominikanische Republik',
  'country.long.DJ': 'Dschibuti',
  'country.long.SV': 'El Salvador',
  'country.long.EC': 'Equador',
  'country.long.ER': 'Eritrea',
  'country.long.EE': 'Estland',
  'country.long.FK': 'Falkland Islands (Malvinas)',
  'country.long.FO': 'Färöer',
  'country.long.FJ': 'Fidschi',
  'country.long.FI': 'Finnland',
  'country.long.FR': 'Frankreich',
  'country.long.GF': 'Französisch-Guayana',
  'country.long.PF': 'Französisch-Polynesien',
  'country.long.TF': 'Französische Süd- und Antarktisgebiete',
  'country.long.GA': 'Gabun',
  'country.long.GM': 'Gambia',
  'country.long.GE': 'Georgien',
  'country.long.GH': 'Ghana',
  'country.long.GI': 'Gibraltar',
  'country.long.GD': 'Grenada',
  'country.long.GR': 'Griechenland',
  'country.long.GL': 'Grönland',
  'country.long.GP': 'Guadeloupe',
  'country.long.GU': 'Guam',
  'country.long.GT': 'Guatemala',
  'country.long.GG': 'Guernsey',
  'country.long.GN': 'Guinea',
  'country.long.GW': 'Guinea-Bissau',
  'country.long.GY': 'Guyana',
  'country.long.HT': 'Haiti',
  'country.long.HM': 'Heard Island and Mcdonald Islands',
  'country.long.VA': 'Holy See (Vatican City State)',
  'country.long.HN': 'Honduras',
  'country.long.HK': 'Hong Kong',
  'country.long.IN': 'Indien',
  'country.long.ID': 'Indonesien',
  'country.long.IQ': 'Irak',
  'country.long.IR': 'Iran',
  'country.long.IE': 'Irland',
  'country.long.IS': 'Island',
  'country.long.IM': 'Isle of Man',
  'country.long.IL': 'Israel',
  'country.long.IT': 'Italien',
  'country.long.JM': 'Jamaika',
  'country.long.JP': 'Japan',
  'country.long.YE': 'Jemen',
  'country.long.JE': 'Jersey',
  'country.long.JO': 'Jordanien',
  'country.long.KY': 'Kaimaninseln',
  'country.long.KH': 'Kambodscha',
  'country.long.CM': 'Kamerun',
  'country.long.CA': 'Kanada',
  'country.long.CV': 'Kapverden',
  'country.long.KZ': 'Kasachstan',
  'country.long.QA': 'Katar',
  'country.long.KE': 'Kenia',
  'country.long.KG': 'Kirgisistan',
  'country.long.KI': 'Kiribati',
  'country.long.CO': 'Kolumbien',
  'country.long.KM': 'Komoren',
  'country.long.HR': 'Kroatien',
  'country.long.CU': 'Kuba',
  'country.long.KW': 'Kuwait',
  'country.long.LA': 'Lao PDR',
  'country.long.LS': 'Lesotho',
  'country.long.LV': 'Lettland',
  'country.long.LB': 'Libanon',
  'country.long.LR': 'Liberia',
  'country.long.LY': 'Libyen',
  'country.long.LI': 'Liechtenstein',
  'country.long.LT': 'Litauen',
  'country.long.LU': 'Luxemburg',
  'country.long.MO': 'Macao',
  'country.long.MG': 'Madagaskar',
  'country.long.MW': 'Malawi',
  'country.long.MY': 'Malaysia',
  'country.long.MV': 'Malediven',
  'country.long.ML': 'Mali',
  'country.long.MT': 'Malta',
  'country.long.MA': 'Marokko',
  'country.long.MH': 'Marshallinseln',
  'country.long.MQ': 'Martinique',
  'country.long.MR': 'Mauretanien',
  'country.long.MU': 'Mauritius',
  'country.long.YT': 'Mayotte',
  'country.long.MK': 'Mazedonien',
  'country.long.MX': 'Mexiko',
  'country.long.FM': 'Mikronesien',
  'country.long.MD': 'Moldawien',
  'country.long.MC': 'Monaco',
  'country.long.MN': 'Mongolei',
  'country.long.ME': 'Montenegro',
  'country.long.MS': 'Montserrat',
  'country.long.MZ': 'Mosambik',
  'country.long.MM': 'Myanmar',
  'country.long.NA': 'Namibia',
  'country.long.NR': 'Nauru',
  'country.long.NP': 'Nepal',
  'country.long.NC': 'Neukaledonien',
  'country.long.NZ': 'Neuseeland',
  'country.long.NI': 'Nicaragua',
  'country.long.NL': 'Niederlande',
  'country.long.AN': 'Niederländische Antillen',
  'country.long.NE': 'Niger',
  'country.long.NG': 'Nigeria',
  'country.long.NU': 'Niue',
  'country.long.KP': 'Nordkorea',
  'country.long.MP': 'Nördliche Marianen',
  'country.long.NF': 'Norfolkinsel',
  'country.long.NO': 'Norwegen',
  'country.long.OM': 'Oman',
  'country.long.AT': 'Österreich',
  'country.long.TL': 'Osttimor',
  'country.long.PK': 'Pakistan',
  'country.long.PW': 'Palau',
  'country.long.PA': 'Panama',
  'country.long.PG': 'Papua-Neuguinea',
  'country.long.PY': 'Paraguay',
  'country.long.PE': 'Peru',
  'country.long.PH': 'Philippinen',
  'country.long.PN': 'Pitcairn',
  'country.long.PL': 'Polen',
  'country.long.PT': 'Portugal',
  'country.long.PR': 'Puerto Rico',
  'country.long.RE': 'Réunion',
  'country.long.RW': 'Ruanda',
  'country.long.RO': 'Rumänien',
  'country.long.RU': 'Russian Federation',
  'country.long.VC': 'Saint Vincent and Grenadines',
  'country.long.BL': 'Saint-Barthélemy',
  'country.long.MF': 'Saint-Martin (French part)',
  'country.long.PM': 'Saint-Pierre und Miquelon',
  'country.long.SB': 'Salomonen',
  'country.long.ZM': 'Sambia',
  'country.long.WS': 'Samoa',
  'country.long.SM': 'San Marino',
  'country.long.ST': 'Sao Tome and Principe',
  'country.long.SA': 'Saudi-Arabien',
  'country.long.SE': 'Schweden',
  'country.long.CH': 'Schweiz',
  'country.long.SN': 'Senegal',
  'country.long.RS': 'Serbien',
  'country.long.SC': 'Seychellen',
  'country.long.SL': 'Sierra Leone',
  'country.long.ZW': 'Simbabwe',
  'country.long.SG': 'Singapur',
  'country.long.SK': 'Slowakei',
  'country.long.SI': 'Slowenien',
  'country.long.SO': 'Somalia',
  'country.long.ES': 'Spanien',
  'country.long.LK': 'Sri Lanka',
  'country.long.SH': 'St. Helena',
  'country.long.KN': 'St. Kitts und Nevis',
  'country.long.LC': 'St. Lucia',
  'country.long.ZA': 'Südafrika',
  'country.long.SD': 'Sudan',
  'country.long.GS': 'Südgeorgien und die Südlichen Sandwichinseln',
  'country.long.KR': 'Südkorea',
  'country.long.SS': 'Südsudan',
  'country.long.SR': 'Surinam',
  'country.long.SJ': 'Svalbard and Jan Mayen Islands',
  'country.long.SZ': 'Swasiland',
  'country.long.SY': 'Syrian Arab Republic (Syria)',
  'country.long.TJ': 'Tadschikistan',
  'country.long.TW': 'Taiwan, Republic of China',
  'country.long.TZ': 'Tansania',
  'country.long.TH': 'Thailand',
  'country.long.TG': 'Togo',
  'country.long.TK': 'Tokelau',
  'country.long.TO': 'Tonga',
  'country.long.TT': 'Trinidad und Tobago',
  'country.long.TD': 'Tschad',
  'country.long.CZ': 'Tschechische Republik',
  'country.long.TN': 'Tunesien',
  'country.long.TR': 'Türkei',
  'country.long.TM': 'Turkmenistan',
  'country.long.TC': 'Turks- und Caicosinseln',
  'country.long.TV': 'Tuvalu',
  'country.long.UG': 'Uganda',
  'country.long.UA': 'Ukraine',
  'country.long.HU': 'Ungarn',
  'country.long.UM': 'United States Minor Outlying Islands',
  'country.long.US': 'United States of America',
  'country.long.UY': 'Uruguay',
  'country.long.UZ': 'Usbekistan',
  'country.long.VU': 'Vanuatu',
  'country.long.VE': 'Venezuela',
  'country.long.AE': 'Vereinigte Arabische Emirate',
  'country.long.GB': 'Vereinigtes Königreich',
  'country.long.VN': 'Viet Nam',
  'country.long.VI': 'Virgin Islands, US',
  'country.long.WF': 'Wallis and Futuna Islands',
  'country.long.CX': 'Weihnachtsinsel',
  'country.long.BY': 'Weißrussland',
  'country.long.EH': 'Westsahara',
  'country.long.CF': 'Zentralafrikanische Republik',
  'country.long.CY': 'Zypern',
};
